import React from 'react';

import { createClassName } from 'utils/createClassName';
import { ServiceHeaderLayoutComponent } from 'design/serviceHeaderLayout';

import './homePageLayoutStyles.scss';

type Props = {
  logo: React.ReactNode;
  accountControls: React.ReactNode;
};

/**
 * TODO: Во многом дублирует ServicePageLayoutComponent.
 * Нужно их как-то совместить или разбить на мелкие компоненты и удалить дубликаты.
 */
export const HomePageLayoutComponent: React.FC<Props> = (props) => {
  const { logo, children, accountControls } = props;

  const createHomePageLayoutClassName = createClassName('homePageLayout');

  const wrapperClassName = createHomePageLayoutClassName('wrapper');

  const cardsSlotClassName = createHomePageLayoutClassName('cardsSlot');

  const contentClassName = createHomePageLayoutClassName('content');

  return (
    <div className={wrapperClassName}>
      <ServiceHeaderLayoutComponent
        logo={logo}
        accountControls={accountControls}
      />
      <div className={contentClassName}>
        <div className={cardsSlotClassName}>{children}</div>
      </div>
    </div>
  );
};
